<template>
  <div>
    <b-table
      :busy="loading"
      ref="table"
      :fields="tableDataFields"
      :items="tableData"
      head-variant="light"
      hover
      class="bg-white"
      show-empty
      sort-icon-left
    >
      <template v-slot:cell(tagType)="data">
        <span>{{data.item.tagType ==='C'? '公共标签':'私有标签' }}</span>
      </template>
      <template v-slot:cell(tagStatus)="data">
        <b-badge
          :variant="data.item.tagStatus === 'Y'?'success':'danger'"
        >{{data.item.tagStatus === 'Y'? '有效':'无效' }}</b-badge>
      </template>
      <template v-slot:cell(modifyInfo)="data">
        <div>
          <span>修改人: {{data.item.modifyByName}}</span>
          <br />
          <span>修改日期: {{data.item.modifyDate}}</span>
        </div>
      </template>
      <template v-slot:cell(operation)="data">
        <b-button-group>
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            :title="$l('tips_view') || '查看'"
            @click="fromLoad('detail', data.item.tagCode)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-eye></b-icon-eye>
          </b-button>
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            :title="$l('tips_edit') || '编辑'"
            @click="fromLoad('edit', data.item.tagCode)"
            variant="outline-secondary"
            size="sm"
            v-if="allow('M')"
          >
            <b-icon-pencil></b-icon-pencil>
          </b-button>
          <b-button
            v-b-tooltip.hover
            :title="$l('tips_del') || '删除'"
            :disabled="data.item.tagStatus === 'N' "
            @click="delRow1([data.item.tagCode])"
            variant="outline-secondary"
            size="sm"
            v-if="allow('D')"
          >
            <b-icon-trash-fill></b-icon-trash-fill>
          </b-button>
        </b-button-group>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:empty="scope">
        <div style="text-align: center;">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
        </div>
      </template>
    </b-table>
    <!--编辑弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="800px"
    >
      <page-detail ref="form" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{$l('form_button_cancel')||'取 消'}}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
        >{{$l('form_button_save')||'保存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  components: {
    PageDetail: () => import("./components/detail"),
  },
  data() {
    return {
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      tableDataFields: [
        {
          key: "tagName",
          label: this.$l("table_label_tag_name") || "标签名称",
          tdClass: "align-middle",
        },
        {
          key: "tagType",
          label: this.$l("table_label_tag_type") || "标签类型",
          tdClass: "align-middle",
        },
        {
          key: "tagOwnerName",
          label: this.$l("table_label_tag_ower") || "标签所属人",
          tdClass: "align-middle",
        },
        {
          key: "tagStatus",
          label: this.$l("table_label_status") || "状态",
          tdClass: "align-middle",
        },
        {
          key: "modifyInfo",
          label: this.$l("table_label_modifyInfo") || "修改信息",
          tdClass: "align-middle",
        },
        {
          key: "operation",
          label: this.$l("table_label_operation") || "操作",
          tdClass: "align-middle",
        },
      ],
    };
  },
  methods: {
    delMultiple() {
      let selection = this.$refs.table.selection;
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message:
            this.$l("INDEX.tips_question_del_rows") || "请选择需要删除的数据",
          type: "warning",
        });
        return;
      }
      let tempArray = [];
      selection.forEach((item) => {
        tempArray.push(item.tagCode);
      });
      this.delRow1(tempArray);
    },
    delRow1(tagCodeList) {
      console.log(tagCodeList);
      this.$confirm(
        this.$l("INDEX.tips_question_delete") || "是否删除？",
        this.$l("INDEX.tips_question_title") || "提示",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api
          .delDesignElementsTagApi({ tagCodeList: tagCodeList })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
              type: "success",
            });
            this.$emit("submit");
          });
      });
    },
    // 加载表单
    fromLoad(ref, val = "") {
      const opt = {
        add: "新增",
        edit: "编辑",
        detail: "详情",
      };
      let key;
      if (ref === "add") {
        key = "tips_add";
      } else if (ref === "edit") {
        key = "tips_edit";
      } else if (ref === "detail") {
        key = "tips_view";
      }
      // 设置标题
      this.formOption.title = this.$l(key) || opt[ref];
      // 控制保存按钮显隐
      if (ref === "detail") {
        this.formOption.dialogSaveBtnVisible = false;
      } else {
        this.formOption.dialogSaveBtnVisible = true;
      }
      // 显示表单
      this.formOption.dialogFormVisible = true;
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val);
      }, 0);
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.cancel();
      this.$emit("submit");
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
    formatterCheckStatus: function (row) {
      return row.tagStatus === "Y"
        ? "有效"
        : row.tagStatus === "N"
        ? "无效"
        : "";
    },
    formatterCheckTypeStatus: function (row) {
      return row.tagType === "C"
        ? "公共标签"
        : row.tagType === "P"
        ? "私有标签"
        : "";
    },
  },
};
</script>
